// Mental Health Affirmations for ElevateMN
// These are displayed on loading screens and after login

export const affirmations = [
  // Core message - weighted more heavily
  "You are not alone.",
  "You are not alone.",
  "You are not alone.",

  // Self-worth
  "You are worthy of love and belonging.",
  "Your presence in this world matters.",
  "You are enough, just as you are.",
  "You deserve to take up space.",
  "Your feelings are valid.",
  
  // Strength & Resilience
  "You have survived 100% of your hardest days.",
  "Healing is not linear, and that's okay.",
  "Every small step forward is progress.",
  "You are stronger than you know.",
  "It's okay to rest. Rest is part of the journey.",
  "You are not alone.",
  
  // Community & Connection
  "You are not alone in this.",
  "Asking for help is a sign of strength.",
  "Community heals what isolation cannot.",
  "Together, we rise.",
  "Your story can help someone else.",
  
  // Hope & Growth
  "Better days are ahead.",
  "Growth happens outside your comfort zone.",
  "Today is a fresh start.",
  "You are capable of change.",
  "Hope is always within reach.",
  "You are not alone.",
  
  // Self-compassion
  "Be gentle with yourself today.",
  "You are doing the best you can.",
  "It's okay to not be okay.",
  "Give yourself the grace you give others.",
  "Your mental health is a priority.",
  
  // Mindfulness & Presence
  "One breath at a time.",
  "This moment is all that matters.",
  "Peace begins within.",
  "Let go of what you cannot control.",
  "You are exactly where you need to be.",
  "You are not alone.",
  
  // Encouragement
  "Keep going. You've got this.",
  "Your journey inspires others.",
  "Believe in your ability to heal.",
  "You make the world a better place.",
  "Your light shines even on dark days."
];

export const getRandomAffirmation = () => {
  const index = Math.floor(Math.random() * affirmations.length);
  return affirmations[index];
};

export const getAffirmationOfTheDay = () => {
  // Use date to get consistent affirmation for the day
  const today = new Date();
  const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / (1000 * 60 * 60 * 24));
  const index = dayOfYear % affirmations.length;
  return affirmations[index];
};
